import { authToken } from "../../utils/helper";
import { baseUrl } from "../../utils/sysEnv";
import * as types from '../types'
import axios from "axios";
import { toast } from "react-toastify";


// GET ALL tariffs
export const getMyAblAccounts = info => async (dispatch) => {
    try {
      dispatch({ type: types.SET_LOADING });
      await axios
        .get(`${baseUrl}/accounts/${info.clientNumber}/${info.ablToken}`, authToken(info.token))
        .then((res) => {
          dispatch({
            type: types.GET_MY_ACCOUNTS,
            payload: res.data.data,
          });
        })
        .catch((error) => {
            toast.error(error.response.data.message);
        });
    } catch (err) {
       toast.error(err.response.data);
    }
  };